import { getNameOrId, ProductNames } from '@/libs/product'
import {
    REQUEST_HANDLING_STRATEGIES,
    RequestHandlingStrategy,
    isRequestHandlingStrategyAllowed,
} from './request-handling-strategy'

const productSupplierDetails = context => {
    const product = context.product || (context.request && context.request.product) || {}

    return {
        name: getNameOrId(product.names || [], ProductNames.SUPPLIERS_PRODUCT_NAME) || '',
        suppliers: Array.isArray(product.suppliers) ? product.suppliers : [],
    }
}

const createRequestHandlingValidation = (
    context = {},
    settings = {},
    overrides = {},
) => {
    const workflowState = context.requestHandling && context.requestHandling.workflowState
        ? context.requestHandling.workflowState
        : { loaded: false, strategy: null }
    const persistedStrategy = workflowState.strategy || null
    const strategy = Object.prototype.hasOwnProperty.call(overrides, 'strategy')
        ? overrides.strategy
        : persistedStrategy
    const details = overrides.supplierDetails || productSupplierDetails(context)
    const hierarchy = context.productHierarchy || {}
    const structureState = context.requestHandling && context.requestHandling.productStructure
        ? context.requestHandling.productStructure
        : { loaded: false }
    const productStructureSettings = {
        requireAtLeastOneComponent: true,
        ...(settings.productStructure || {}),
    }
    let isValid = workflowState.loaded === true
        && REQUEST_HANDLING_STRATEGIES.includes(strategy)
        && isRequestHandlingStrategyAllowed(strategy, context, settings)
        && strategy === persistedStrategy

    if (
        settings.showProductSupplierDetails !== false
        && strategy === RequestHandlingStrategy.FORWARD_TO_PRODUCT_SUPPLIER
    ) {
        isValid = isValid
            && Array.isArray(details.suppliers)
            && details.suppliers.length > 0
            && String(details.name || '').trim().length > 0
    }

    if (
        settings.showProductStructure === true
        && strategy === RequestHandlingStrategy.COLLECT_FROM_COMPONENT_SUPPLIERS
        && productStructureSettings.requireAtLeastOneComponent
    ) {
        isValid = isValid
            && structureState.loaded === true
            && Array.isArray(hierarchy.children)
            && hierarchy.children.length > 0
    }

    return { isValid, errors: [] }
}

export { createRequestHandlingValidation }
export default createRequestHandlingValidation
